// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3wvE7","have_a_question_section":"Form_have_a_question_section__3VB-L"};